import type { SupabaseClient } from '@supabase/supabase-js';

export async function getPage(
	balancedSupabase: SupabaseClient,
	id: string
): Promise<SupabaseClient> {
	const { data: page, error } = await balancedSupabase
		.from('pages')
		.select(
			`
				*,
				video:videos(*)
			`
		)
		.eq('id', id)
		.single();
	if (error) {
		console.error(error);
		return {};
	}
	return page;
}
